export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{translations.YourAccount}}
	</div>
	<div class="change-container">
		<div class="change-container__type">
			<button class="change-type-js replace-template-js change-container__type text {% if include == 'account' %} active {% endif %}" data-template="partials/customer-profile/your-account/employee-data.html" data-container=".employee-data-js" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=your-account">{{ translations.AccountDetails }}</button>
		</div>
		<div class="change-container__type">
			<button class="change-type-js replace-template-js change-container__type text {% if include == 'history' %} active {% endif %}" data-template="partials/customer-profile/your-account/history.html" data-container=".employee-data-js" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=history">{{ translations.AccountHistory }}</button>
		</div>
		<div class="slider"></div>
	</div>
	<div class="promises-message-js promises-message"></div>
	<div class="employee-data-js container-js">
		{% if page.QueryString contains 'your-account' -%}
			{% include 'partials/customer-profile/your-account/employee-data.html' -%}
		{% else -%}
			{% include 'partials/customer-profile/your-account/history.html' -%}
		{% endif -%}
	</div>
</div>
`